/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TransferCaptainBody
 */
export interface TransferCaptainBody {
    /**
     * User ID of new captain
     * @type {string}
     * @memberof TransferCaptainBody
     */
    newCaptainUserId?: string;
    /**
     * Index of member to promote (0-based)
     * @type {number}
     * @memberof TransferCaptainBody
     */
    newCaptainIndex?: number;
}

/**
 * Check if a given object implements the TransferCaptainBody interface.
 */
export function instanceOfTransferCaptainBody(value: object): value is TransferCaptainBody {
    return true;
}

export function TransferCaptainBodyFromJSON(json: any): TransferCaptainBody {
    return TransferCaptainBodyFromJSONTyped(json, false);
}

export function TransferCaptainBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransferCaptainBody {
    if (json == null) {
        return json;
    }
    return {
        
        'newCaptainUserId': json['newCaptainUserId'] == null ? undefined : json['newCaptainUserId'],
        'newCaptainIndex': json['newCaptainIndex'] == null ? undefined : json['newCaptainIndex'],
    };
}

export function TransferCaptainBodyToJSON(json: any): TransferCaptainBody {
    return TransferCaptainBodyToJSONTyped(json, false);
}

export function TransferCaptainBodyToJSONTyped(value?: TransferCaptainBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'newCaptainUserId': value['newCaptainUserId'],
        'newCaptainIndex': value['newCaptainIndex'],
    };
}

